import script from "./Stream.vue?vue&type=script&setup=true&lang=js"
export * from "./Stream.vue?vue&type=script&setup=true&lang=js"

import "./Stream.vue?vue&type=style&index=0&id=c8b24454&scoped=true&lang=css"

import exportComponent from "/home/artur/Documents/bemyvega-gitlab/platform-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8b24454"]])

export default __exports__